import { useContext, useMemo } from 'react'

import { InstitutionContext } from '../../../Providers/InstitutionProvider'
import EntityList from './EntityList'
import { isObject } from '../../../utils'

const renderLabel = school => school.abbreviation ? `${school.abbreviation} - ${school.name}` : school.name
const keywords = school => [school.name, school.abbreviation]

const SchoolsList = ({ excluded = null, maxHeight, pinned = null, schools = null, selected, onSelectedChange }) => {
  const ic = useContext(InstitutionContext)

  const entities = useMemo(() => schools ?? (isObject(ic) ? ic.schools : []), [schools, ic])

  return (
    <EntityList
      entities={entities}
      excluded={excluded}
      keywords={keywords}
      maxHeight={maxHeight}
      pinned={pinned}
      renderLabel={renderLabel}
      selected={selected}
      onSelectedChange={onSelectedChange}
    />
  )
}

export default SchoolsList
